export const getWebPushToken = () => {
  return 'will_be_later';
};
